<template>
	<section class="inner-menu-section" :class="isFooter ? 'footer-title' : ''">
		<h1
			class="font-89 f-roman fade-up"
			v-in-viewport.once
			:class="{ 'no-data': !_.get(getTabMenus, 'children') }"
		>
			{{ _.get(getTabMenus, 'title') }}
		</h1>
		<div class="inner-menu-list fade-up" v-in-viewport.once>
			<div v-for="(item, index) in _.get(getTabMenus, 'children')" :key="index">
				<a
					:href="item.full_url"
					class="inner-menu-list-item pointer"
					v-if="_.get(item, 'url') === 'grants-database'"
					:class="{
						active: item.id == _.get($store.state.main, 'selected_menu.id'),
					}"
				>
					{{ item.title }}
				</a>
				<router-link
					v-if="
						item && item.configs != 'hide-from-menu' && _.get(item, 'url') !== 'grants-database'
					"
					tag="a"
					:to="item.full_url"
					class="inner-menu-list-item pointer"
					:key="index"
					:class="{
						active: item.id == _.get($store.state.main, 'selected_menu.id'),
					}"
				>
					{{ item.title }}
				</router-link>
			</div>
		</div>
	</section>
</template>
<script>
import Main from '@/mixins/main';
export default {
	mixins: [Main],
	props: ['tabs', 'isFooter'],
	data() {
		return {};
	},
	computed: {
		getTabMenus() {
			let menus = this.makeMenuTree();
			const selectedPid = _.get(this.$store.state.main, 'selected_menu.pid');

			let data = menus.find((menu) => menu.id === selectedPid);

			if (!data) {
				return this.$store.state.main.selected_menu;
			}
			return menus.find((menu) => menu.id === selectedPid);
		},
	},
};
</script>

<style lang="scss">
.no-data {
	padding-bottom: 55px;
}
</style>
